<template>
    <div>

        <z-update-org-basic ref="updateOrgBasic" @updateSuccess="refreshTree"></z-update-org-basic>
        
        <z-update-org-custom ref="updateOrgCustom"  @updateSuccess="refreshTree"></z-update-org-custom>
        <z-update-org-locate ref="updateOrgLocate"  @updateSuccess="refreshTree"></z-update-org-locate>
        <z-reset-password ref="resetPassword"></z-reset-password>
        <ZUpdateOrgSms ref="updateOrgSms"  @updateSuccess="refreshTree"/>
        <CreateUser ref="createOrgUser"  @updateSuccess="refreshTree" />
        <!-- 修改页面布局为tabs 不出现滚动条 -->
        <a-tabs defaultActiveKey="1">
            <a-tab-pane :tab="$t('global.basicInfo')" key="1">
                <a-card>
                    <div style="font-weight:500;font-size:18px">
                        {{$t('global.basicInfo')}}
                        <a-button :disabled="roles.includes('Attach') || (org.users && org.users.length >= 4)" style="left:5%" type="primary" icon="edit" size="small" @click="editBasicInfo(org)">{{$t('global.edit')}}</a-button>
                    </div>
                    <a-divider />
                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{org.level == 2 ? $t('org.integrator') : $t('org.orgName')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.name}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{org.level == 2 ? $t('org.integratorDescription') : $t('org.orgDescription')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.remark ? org.remark : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{org.level == 2 ? $t('org.integratorAddress') : $t('org.orgAddress')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.address}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.createTime')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{timeFormat(org.createTimestamp)}}</div>
                        </a-col>

                        <a-col v-show="computedOrgRole(org.link)" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.parentName')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.parentName ? org.parentName : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.linkMan')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.contacts ? org.contacts : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.phone')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.contactsPhone ? org.contactsPhone : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.email')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.email ? org.email : '---'}}</div>
                        </a-col>

                        <!-- <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">状态</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.expireTime ? orgStatus(org.expireTime) : '正常'}}</div>
                        </a-col> -->

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.usefulLife')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.expireTime ? timeFormat(org.expireTime,'YYYY-MM-DD') : '---'}}</div>
                        </a-col>
                    </a-row>
                </a-card>
            </a-tab-pane>

            <a-tab-pane :tab="$t('org.userInfo')" key="2">
                <a-card   style="margin-top:10px">
                    <div style="font-weight:500;font-size:18px">
                        {{$t('org.userInfo')}}
                        <!-- <a-button style="left:5%" type="primary" icon="edit" size="small" @click="editUserInfo(org)">{{$t('global.edit')}}</a-button> -->
                        <!-- <a-button style="left:8%" icon="edit" size="small" @click="resetPassword(org)" v-if="!isIntegrator && org.pid">{{$t('global.resetPassword')}}</a-button> -->
                        <a-button :disabled="roles.includes('Attach') || (org.users && org.users.length >= 4)" style="left:5%" type="primary" icon="edit" size="small" @click="createUser(org.id)">{{$t('org.createUser')}}</a-button>
                    </div>
                    <a-divider />
                    <template v-for="(user, index) in org.users">
                      <OrgUser @refresh="refreshTree" :key="index" :user="user" :orgId="org.id" />
                    </template>
                    
                </a-card>
            </a-tab-pane>

            <a-tab-pane :tab="$t('org.smsService')" key="3">
                <a-card style="margin-top:10px">
                    <div style="font-weight:500;font-size:18px">
                        {{$t('org.smsService')}}
                        <a-button :disabled="roles.includes('Attach') || (org.users && org.users.length >= 4)" v-if="org.pid" style="left:5%" type="primary" icon="diff" size="small" @click="rechargeSms(org.id)">{{$t('org.recharge')}}</a-button>
                    </div>

                    <a-divider />

                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.smsNum')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{orgSmsNum}}</div>
                        </a-col>

                        <a-col  v-if="!computedOrgRole(org.link)" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.isShare')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">
                              <a-switch @change="onSmsSwitched" :defaultChecked="true" :checked="isApplyToChild" size="small"></a-switch>
                            </div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.receiveUser')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.contacts ? org.contacts : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.receivePhone')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.contactsPhone ? org.contactsPhone : '---'}}</div>
                        </a-col>
                    </a-row>
                </a-card>
            </a-tab-pane>

             <a-tab-pane :tab="$t('org.customInfo')" key="4">
                <a-card style="margin-top:10px"  class="item">
                    <div style="font-weight:500;font-size:18px">
                        {{$t('org.customInfo')}}
                        <a-button :disabled="roles.includes('Attach') || (org.users && org.users.length >= 4)" style="left:5%" type="primary" icon="edit" size="small" @click="editCustomInfo(org)">{{$t('global.edit')}}</a-button>
                    </div>

                    <a-divider />

                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}" v-if="isSuperAdmin || isIntegrator">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.entityTemplate')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.entityTemplateName ? org.entityTemplateName : '---'}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.systemName')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.systemName ? org.systemName : '---'}}</div>
                        </a-col>

                        

                        <a-col style="padding-left:16px;padding-right:16px;line-height: 20px;color: rgba(0, 0, 0, 0.85)" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div style="white-space: nowrap;float:left">{{$t('org.systemLogo')}}：</div>
                            <div class="antd-pro-components-description-list-index-detail">
                                <!-- <a-avatar shape="square" size="large" v-if="org.logo" :src= "org.logo"/> -->
                                <img style="max-width: 50px" v-if="org.logo" :src="org.logo"  alt="LOGO">
                                <span v-else>---</span>
                            </div>
                        </a-col>
                    </a-row>
                </a-card>
            </a-tab-pane>

            <a-tab-pane :tab="$t('org.locationInfo')" key="5">
                <a-card style="margin-top:10px" class="item">
                    <div style="font-weight:500;font-size:18px">
                        {{$t('org.locationInfo')}}
                        <a-button :disabled="roles.includes('Attach') || (org.users && org.users.length >= 4)" style="left:5%" type="primary" icon="edit" size="small" @click="editLocateInfo(org)">{{$t('global.edit')}}</a-button>
                    </div>
                    <a-divider />

                    <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{org.level == 2 ? $t('org.integratorAddress') : $t('org.orgAddress')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{org.address}}</div>
                        </a-col>

                        <a-col style="padding:16px;" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <BMap :hasZoom="false" height="400" @getMap="getMap" />
                        </a-col>
                    </a-row>
                </a-card>
            </a-tab-pane>
        </a-tabs>

    </div>
</template>

<script>
    import ZUpdateOrgBasic from '@/views/org/UpdateOrgBasic.vue'
    import CreateUser from './CreateUser'
    import ZUpdateOrgCustom from '@/views/org/UpdateOrgCustom.vue'
    import ZUpdateOrgLocate from '@/views/org/UpdateOrgLocate.vue'
    import ZUpdateOrgSms from '@/views/org/UpdateOrgSmsNum.vue'
    import ZResetPassword from '@/views/org/ResetPassword.vue'
    import BMap from '../../components/common/BMap'
    import moment from 'moment'
    import {mapGetters} from 'vuex'
    import config from '../../config/'
    import {httpModel} from '../../http/httpModel'
    import bus from '../../bus/bus';
    import {computedOrgRole} from '../../utils/globalFunction'

    export default {
        name: 'ZOrgDetail',
        props:['entityTemplates'],
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator','roles'
            ])
        },
        data() {
            return {
                org:{},
                marker: null,
                chartSettings: [],
                chartSeries: [],
                bmap: null,
                orgSmsNum: 0,
                isApplyToChild: false
            }
        },
        components:{
            ZUpdateOrgBasic,
            
            ZUpdateOrgCustom,
            ZUpdateOrgLocate,
            ZUpdateOrgSms,
            ZResetPassword,
            BMap,
            OrgUser: () => import('./OrgUser'),
            // CreateUser: () => import('./CreateUser')
            CreateUser
        },
        methods:{
          computedOrgRole,
            getMap (map) {
                this.bmap = map
                this.afterSet()
            },
            onSmsSwitched (checked) {
              // console.log(this.isApplyToChild)
              // console.log(this.org)
              let param = {
                orgLink: this.org.link,
                isShare: checked
              }
              httpModel.setShareSms(param).then((res) => {
                // console.log(res)
                this.isApplyToChild = res
                this.$notification.success({
                  message: res ? this.$t('org.enableShare') : this.$t('org.disableShare')
                })
              })
            },
            refreshTree(nodeId){
                this.$emit("refreshTree",nodeId)
            },
            // 短信充值
            rechargeSms(id) {
                this.$refs["updateOrgSms"].showModel(id)
            },
            editBasicInfo(org){
                // console.log(org)
                this.$refs["updateOrgBasic"].showModel(this.clone(org))
            },
            createUser (orgId) {
              console.log(orgId)
              this.$refs["createOrgUser"].showModel(orgId)
            },
            
            resetPassword(org){
                this.$refs["resetPassword"].showModel(this.clone(org.user.id))
            },
            editCustomInfo(org){
                this.$refs["updateOrgCustom"].showModel(this.clone(org))
            },
            editLocateInfo(org){
                bus.$emit('removeCityControl')
                this.$refs["updateOrgLocate"].showModel(this.clone(org))
            },
            orgStatus(expireTime){
                return moment().valueOf()/1000 < expireTime ? this.$t('global.enable') : this.$t('global.disable')
            },
            timeFormat(timestamp,fomatter) {
                if(fomatter){
                    return moment(timestamp * 1000).format(fomatter)
                }
                return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
            },
            // 获取剩余短信数量
            getSmsNum (id) {
                // console.log('getsms')
                this.$http.get(config.api.get_org_sms_num + `${id}`).then((res) => {
                    // console.log(res)
                    if (res.code === 0) {
                        this.orgSmsNum = res.result
                    }
                })
            },
            setOrg(org){
                this.org = org
                console.log(this.org)
                // 默认值
                this.isApplyToChild = this.org.shareSmsNum || false
                let _this = this
                if(this.bmap){
                    setTimeout(() => {
                        _this.bmap.removeOverlay(_this.marker)
                        let point  = new window.BMap.Point(_this.org.lng,_this.org.lat)
                        _this.marker = new window.BMap.Marker(point)
                        _this.bmap.centerAndZoom(point,_this.org.mapLevel)
                        _this.bmap.addOverlay(_this.marker)
                        _this.marker.setAnimation(window.BMAP_ANIMATION_BOUNCE)
                    },200)
                }
            },
            afterSet () {
                // this.bmap = echarts.getModel().getComponent('bmap').getBMap();
                let point  = new window.BMap.Point(this.org.lng,this.org.lat)
                let marker = new window.BMap.Marker(point)
                this.bmap.centerAndZoom(point,this.org.mapLevel)
                this.bmap.addOverlay(marker)
                marker.setAnimation(window.BMAP_ANIMATION_BOUNCE)
                this.marker = marker
            },
            clone(obj){
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        },
        mounted () {
            // 添加控件
            bus.$on('MapDestroy', () => {
                // console.log(1)
                bus.$emit('addCityControl')
            })
        },
        created () {
            // this.chartSettings = {
            //     key: '9EEbT6lDGX5RN6M31tGQMtgEXPghbRAO',
            //     bmap: {
            //         center: [116.417854, 39.921988],
            //         zoom: 18,
            //         roam: true,
            //         mapStyle: {}
            //     }
            // }
            // this.chartSeries = []

        }
    }
</script>

<style lang="less" scope>
    .antd-pro-components-description-list-index-term {
        display: table-cell;
        padding-bottom: 16px;
        color: rgba(0,0,0,.85);
        line-height: 20px;
        white-space: nowrap;
    }
    .antd-pro-components-description-list-index-detail {
        display: table-cell;
        width: 100%;
        padding-bottom: 16px;
        color: rgba(0,0,0,.65);
        line-height: 20px;
    }
    .antd-pro-components-description-list-index-term::after {
        position: relative;
        top: -.5px;
        margin: 0 8px 0 2px;
        content: ":";
    }
    /* .item {
        height: 60vh;
    } */
</style>